import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { UntypedRegionTileFragment } from "../../client/generated";
import { RegionTile } from "../../regions/RegionTile";

type Props = {
  fragment: UntypedRegionTileFragment;
  children: React.ReactNode;
  dispatch: Dispatch<EditorAction>;
};

export function UntypedRegionTile({ fragment, children, dispatch }: Props) {
  const onClick = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "update",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTile fragment={fragment} preview="" onClick={onClick}>
      {children}
    </RegionTile>
  );
}
